import actionTypes from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SELECT_RETAILER:
      return { ...action.retailer };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/reducers/selected-retailer.js